import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

function DateContainer({ cellDate, isToday, children = null }) {
  const weekDay = cellDate.format('ddd');
  const day = cellDate.format('D');

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography
        variant="subtitle2"
        sx={{
          alignSelf: 'flex-start',
          mb: 1,
          ...(isToday ? { fontWeight: 700 } : { fontWeight: 'normal' }),
        }}>
        <FormattedMessage id={weekDay.toUpperCase()} defaultMessage={weekDay} />{' '}
        {day}
      </Typography>
      {children}
    </Box>
  );
}

export default DateContainer;
